module.exports = __webpack_public_path__ + "img/icon-game-21566.e890b340.png";